import { Fragment } from 'react';
import { featureValue, monthlyPrice } from './SubscriptionCard';

export default function SubscriptionComparison({ plans, featureGroups }) {
  return (
    <section className="subscription-comparison" aria-labelledby="subscription-comparison-title">
      <div className="subscription-section-heading"><p className="subscription-eyebrow">THE DETAILS, SIDE BY SIDE</p><h2 id="subscription-comparison-title">Find your fit.</h2><p>Every benefit, clearly laid out. Swipe or scroll the table on smaller screens.</p></div>
      <div className="subscription-table-scroll" role="region" aria-label="Subscription benefit comparison" tabIndex={0}>
        <table>
          <caption className="subscription-sr-only">Monthly subscription benefits by plan. Certification details and interview prices are pending.</caption>
          <thead><tr><th scope="col">Your benefits</th>{plans.map(plan => <th scope="col" key={plan.id}>{plan.name}<small>{monthlyPrice(plan.price)} / month</small></th>)}</tr></thead>
          <tbody>{featureGroups.map(group => (
            <Fragment key={group.id}>
              <tr className="subscription-table-group"><th colSpan={plans.length + 1} scope="colgroup">{group.label}</th></tr>
              {group.features.map(feature => (
                <tr key={feature.id}><th scope="row">{feature.label}</th>{plans.map(plan => <td key={plan.id} className={feature.values[plan.id] === false || feature.values[plan.id] === 0 ? 'subscription-excluded' : ''}>{featureValue(feature, plan.id)}</td>)}</tr>
              ))}
            </Fragment>
          ))}</tbody>
        </table>
      </div>
    </section>
  );
}
